import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { cn } from "@core/lib/utils";

interface SpinnerProps {
  size?: SizeProp;
  icon?: IconProp;
  className?: string;
}

const Spinner = (props: SpinnerProps) => {
  return (
    <FontAwesomeIcon
      className={cn("animate-spin inline-block", props.className)}
      size={props.size ?? "lg"}
      icon={props.icon ?? faSpinnerThird}
    />
  );
};

export default Spinner;
